import FormViewForm from '@src/components/_forms/FormViewForm';
import {IClientModel} from '@src/@interfaces/models/Client/IClientModel';
import PaymentTypeAdditionalFieldsField from './fields/PaymentTypeAdditionalFieldsField';
import {IPaymentTypeAdditionalFieldModel} from '@src/@interfaces/models/PaymentType/IPaymentTypeAdditionalFieldModel';

const customFields = {
    additional_fields: {
        component: PaymentTypeAdditionalFieldsField
    },
};

export default class PaymentTypeForm<Model extends IClientModel> extends FormViewForm<Model> {
    protected get customFields() {
        return customFields;
    }

    protected mutateModelFieldInitialValue(fieldName: string, modelValue: any): any {
        if (fieldName === 'additional_fields' && Array.isArray(modelValue)) {
            return (modelValue as IPaymentTypeAdditionalFieldModel[]).map(item => {
                return {
                    id: item.id,
                    label: item.label,
                    type: item.type,
                    is_required: item.is_required,
                };
            });
        }

        return super.mutateModelFieldInitialValue(fieldName, modelValue);
    }
}
